import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=987e793a&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=987e793a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987e793a",
  null
  
)

export default component.exports